/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as auth from "../../../util/auth";
import { handleLogout as requestLogout } from "../../../services/auth";
import { Dropdown } from "react-bootstrap";
import Swal from "sweetalert2";

const breadcrumbHelper = {
  "/clients/permissions": {
    displayName: "Client Permissions",
    path: "/clients/permissions",
  },
};

const UserMenuToogle = React.forwardRef(
  ({ children, onClick, theme, ...props }, ref) => {
    const { firstName = "", lastName = "", name } = auth.getLoggedInData();

    return (
      <a
        href=""
        ref={ref}
        className="nav-link navbar-avatar text-primary"
        data-toggle="dropdown"
        aria-expanded="false"
        data-animation="scale-up"
        role="button"
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        <span className="d-inline-flex mr-2 justify-content-center text-gray-700">
          {firstName ? firstName + " " + lastName : name}
        </span>
      </a>
    );
  },
);

const getBreadCrumb = (activePage, location) => {
  if (!activePage && breadcrumbHelper[location.pathname]) {
    const { displayName } = breadcrumbHelper[location.pathname];
    return (
      <li className="breadcrumb-item">
        <button className="border-0 outline-0 cursor-none flex gap-2 items-center ml-2">
          <Link
            className="text-gray-600 cursor-pointer underline-offset-4 hover:underline hover:!text-gray-600"
            to="/home"
          >
            Home
          </Link>{" "}
          <span className="text-gray-600">/</span>
          <span className="text-black cursor-text">{displayName}</span>
        </button>
      </li>
    );
  }

  return (
    <li className="breadcrumb-item">
      <button className="border-0 outline-0 cursor-none flex gap-2 items-center ml-2">
        <Link
          className="text-gray-600 cursor-pointer underline-offset-4 hover:underline hover:!text-gray-600"
          to="/home"
        >
          Home
        </Link>{" "}
        {activePage?.path === "/transaction-detail" && (
          <React.Fragment>
            <span className="text-gray-600">/</span>
            <Link
              className="text-gray-600 cursor-pointer underline-offset-4 hover:underline hover:!text-gray-600"
              to="/allTransaction"
            >
              Insurance Verifications
            </Link>
          </React.Fragment>
        )}
        {activePage?.path === "/user-form" && (
          <React.Fragment>
            <span className="text-gray-600">/</span>
            <Link
              className="text-gray-600 cursor-pointer underline-offset-4 hover:underline hover:!text-gray-600"
              to="/users"
            >
              Users
            </Link>
          </React.Fragment>
        )}
        <span className="text-gray-600">/</span>
        <span className="text-black cursor-text">{activePage.displayName}</span>
      </button>
    </li>
  );
};

const TemplateHeader = ({
  showAsideMenu,
  showDropDownUserMenu,
  showDotsMenu,
  setShowAsideMenu,
  showFullSizeLogo,
  setShowDropDownUserMenu,
  setShowDotsMenu,
  theme,
  activePage,
  ...props
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogoutClick = async (event) => {
    event.preventDefault();

    if (isLoggingOut) {
      return;
    }

    setIsLoggingOut(true);
    Swal.fire({
      title: "Signing out",
      text: "Your session is being closed. Please wait...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const [success] = await requestLogout();

    if (!success) {
      setIsLoggingOut(false);
      Swal.fire({
        icon: "error",
        title: "Logout failed",
        text: "We could not close your session. Please try again.",
      });
      return;
    }

    Swal.update({
      title: "Session closed",
      text: "Redirecting you to login...",
      icon: "success",
      showConfirmButton: false,
    });
    Swal.hideLoading();

    window.setTimeout(() => {
      auth.logout();
      Swal.close();
      navigate("/login", { replace: true });
    }, 1500);
  };

  return (
    <div
      className="site-navbar navbar navbar-default navbar-fixed-top navbar-mega"
      role="navigation"
      style={{
        backgroundColor: theme.primary,
        boxShadow: "none",
      }}
    >
      <div className="navbar-header">
        <button
          type="button"
          className="navbar-toggler hamburger hamburger-close navbar-toggler-left hided"
          data-toggle="menubar"
          onClick={setShowAsideMenu}
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="hamburger-bar"></span>
        </button>
        <button
          type="button"
          className="navbar-toggler collapsed"
          data-target="#site-navbar-collapse"
          data-toggle="collapse"
          onClick={setShowDotsMenu}
        >
          <i className="icon wb-more-horizontal" aria-hidden="true"></i>
        </button>
        <div
          className={`${showFullSizeLogo ? "text-center" : "text-left"}`}
          data-toggle="gridmenu"
        >
          <img
            alt="Logo"
            className="navbar-brand-logo"
            src={showFullSizeLogo ? theme.miniSizeLogo : theme.fullSizeLogo}
            style={{
              height: showFullSizeLogo ? "3rem" : "3rem",
              marginLeft: !showFullSizeLogo ? "20px" : "0px",
            }}
            title="Dental Robot logo"
          />
        </div>
      </div>

      <div className="navbar-container container-fluid">
        <div
          className={
            showDotsMenu
              ? "collapse navbar-collapse navbar-collapse-toolbar show"
              : "collapse navbar-collapse navbar-collapse-toolbar"
          }
          id="site-navbar-collapse"
        >
          <ul className="nav navbar-toolbar">
            <li className="nav-item hidden-float" id="toggleMenubar">
              <a
                href="#"
                className="nav-link"
                data-toggle="menubar"
                onClick={(ev) => {
                  ev.preventDefault();
                  setShowAsideMenu();
                }}
                role="button"
              >
                <i className={"icon hamburger unfolded"}>
                  <span className="sr-only">Toggle menubar</span>
                  <span className="hamburger-bar"></span>
                </i>
              </a>
            </li>
            {getBreadCrumb(activePage, location)}
          </ul>

          <ul className="nav navbar-toolbar navbar-right navbar-toolbar-right">
            <li className="nav-link">
              <button
                type="button"
                className="text-secondary"
                style={{
                  background: "transparent",
                  border: 0,
                  cursor: isLoggingOut ? "not-allowed" : "pointer",
                  lineHeight: "165%",
                  padding: 0,
                }}
                onClick={handleLogoutClick}
                disabled={isLoggingOut}
              >
                <i className="icon wb-power" aria-hidden="true"></i>{" "}
                {isLoggingOut ? "Signing out..." : "Logout"}
              </button>
            </li>
            <li className="mr-3 mt-1">
              <Dropdown>
                <Dropdown.Toggle
                  as={UserMenuToogle}
                  id="dropdown-custom-components"
                  theme={theme}
                ></Dropdown.Toggle>
                <Dropdown.Menu align="right" className="w-50">
                  <Dropdown.Item as={Link} to="/profile">
                    <i className="icon wb-user" aria-hidden="true"></i> Profile
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/login-history">
                    <i className="icon wb-book" aria-hidden="true"></i> Login
                    History
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TemplateHeader;
